import React, {Component} from 'react';
import styles from 'css/components/loader.css';

/**
 * Page Loader
 */
export class PageLoader extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const {
      view,
    } = this.props;

    return (
      <div className={styles.page} data-view={view} />
    );
  }
}

/**
 * Action Loader
 */
export class ActionLoader extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const {
      view,
    } = this.props;

    return (
      <div className={styles.action} data-view={view} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/loader/index.js